import React from "react";
import PropTypes from "prop-types";
import Amplify, { Auth } from "aws-amplify";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withAlert } from "react-alert";
import { ToastContainer, toast } from "react-toastify";
import {
  getSettlemetEnrichmentQuestion,
  getAllSettlement,
  saveSettlementAnswers,
  getEnrollSettlementForUser,
  getAlLFeatureSettlement,
  saveEnrichmentAnswer,
  getAllCategory,
  getAllFilteredSettlement,
  clearDataSettlmentanswers
} from "../../Actions/actions";
import * as SecretKeys from "../../ENV.json";
import SettlementListComponent from "./settlementListComponent";
import loader from "../../images/Spin-1s-107px.gif";
import "react-toastify/dist/ReactToastify.css";

Amplify.configure(SecretKeys.awsUserpool);

class SettlementListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allSettlementData: [],
      ReciveSettlmentanswersResponseData: {},
      selectedMenuItem: "dashboard",
      userid: localStorage.getItem("userId"),
      isLoader: false,
      response: false,
      intervalId: 0
    };
    this.saveEnrichmentAnswer = this.saveEnrichmentAnswer.bind(this);
    this.saveAnserTOQuestion = this.saveAnserTOQuestion.bind(this);
    this.successMessage = this.successMessage.bind(this);
  }

  /**
   * Save anser to question
   * @param {*} questionObj
   */
  saveAnserTOQuestion(questionObj) {
    this.props.saveSettlementAnswers(questionObj);
  }

  successMessage() {
    return toast.info("Success...");
  }

  /**
   * Get User Info
   */
  componentDidMount() {
    this.props.getAllFilteredSettlement({
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: "",
      catgoryId: 0,
      sortBy: "",
      userId: this.state.userid,
      searchType: "All"
    });
    this.setState({
      isLoader: true,
      userid: localStorage.getItem("userId")
    });
  }

  /**
   * Get Settlements on page load
   */
  componentWillMount() {
    if (localStorage.getItem('paymentStatus') === 'pending'
        && !!localStorage.getItem('paymentFailedButLetUserIn') === false) {
      this.context.router.history.push('/add-payment-method');
    }
    // if (localStorage.getItem("paymentStatus") === "pending") {
    //   // localStorage.clear();
    //   Auth.signOut()
    //     .then(async () => {
    //       // await this.props.logoutUser();
    //       // this.props.clearDataEmail();
    //       //this.context.router.history.push("/");
    //     })
    //     .catch(error => error);
    // }
    const userObject = JSON.parse(localStorage.getItem("userObject"));
    if (userObject) {
      if (typeof userObject.userDto !== "undefined") {
        if (typeof userObject.userDto.roleName !== "undefined") {
          if (userObject.userDto.roleName === "Affiliate") {
            this.context.router.history.push("/affiliate");
            // if(userObject.userDto.parentAffiliateUser === "Yes"){
            //   router.history.push("/parent-affiliate");
            // }else{
            //   router.history.push("/affiliate");
            // }
          }
          // console.log('right here');
        }
      }
    }

    this.props.getAllCategory({ searchKeyword: "" });
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({
      isLoader: true,
      intervalId
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState || this.props !== nextProps) {
      return true;
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    const settleRecord = nextProps.data.setFilteredSettlement;
    const AllCategory = nextProps.data.AllCategory;
    this.setState({
      allSettlementData: settleRecord,
      AllCategoryData: AllCategory,
      isLoader: false
    });

    if (this.state.isLoader === true) {
      this.setState({
        response: true
      });
    }
  }

  componentWillUnmount() {
    this.props.clearDataSettlmentanswers();
  }

  componentDidUpdate() {
    const { ReciveSettlmentanswersResponse } = this.props.data;
    const { ReciveSettlmentanswersResponseData } = this.state;
    // const opts = { position: 'top-center' };
    if (ReciveSettlmentanswersResponse !== undefined) {
      if (
        ReciveSettlmentanswersResponse.eligibilityQuestionDtoList !== undefined
      ) {
        if (
          ReciveSettlmentanswersResponse.eligibilityQuestionDtoList.length > 0
        ) {
          if (
            ReciveSettlmentanswersResponseData !==
            ReciveSettlmentanswersResponse.eligibilityQuestionDtoList
          ) {
            this.setState({
              ReciveSettlmentanswersResponseData:
                ReciveSettlmentanswersResponse.eligibilityQuestionDtoList,
              isLoader: true
            });
            // if (ReciveSettlmentanswersResponseData.length > 0) {

            // }

            if (ReciveSettlmentanswersResponse.enrollmentId !== "") {
              this.props.getAllFilteredSettlement({
                pageNumber: 0,
                pageSize: 5,
                searchKeyword: "",
                catgoryId: 0,
                sortBy: "",
                userId: this.state.userid,
                searchType: "All"
              });
              // toast.info('user enrolls successfully', opts);
              // toast.info('user enrolls successfully', {
              //   position: toast.POSITION.TOP_CENTER,
              // });
            }
          }
        }
      }
    }
  }

  /**
   * Save Question Answer
   */
  saveEnrichmentAnswer(queId, ans) {
    const data = {
      userId: this.state.userid,
      value: ans,
      enrichmentQuestionId: queId
    };
    this.props.saveEnrichmentAnswer(data);
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  render() {
    const {
      selectedMenuItem,
      allSettlementData,
      AllCategoryData,
      isLoader,
      response
    } = this.state;
    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    return (
      <div className="container">
        {loader1}
        <span />
        <ToastContainer autoClose={5000} />
        <div className="main-content bg-grey">
          <SettlementListComponent
            allSettlementDatawe={allSettlementData}
            selectedMenuItem={selectedMenuItem}
            allCategoryDatawe={AllCategoryData}
            answerToQuestionAction={this.saveAnserTOQuestion}
            isLoader={isLoader}
            response={response}
          />
        </div>
      </div>
    );
  }
}

SettlementListContainer.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSettlemetEnrichmentQuestion,
      getAllSettlement,
      saveSettlementAnswers,
      getEnrollSettlementForUser,
      getAlLFeatureSettlement,
      saveEnrichmentAnswer,
      getAllCategory,
      getAllFilteredSettlement,
      clearDataSettlmentanswers
    },
    dispatch
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SettlementListContainer)
);
